import { reportSGM } from '@jdt-jinke/jdpay_utils'
import { loadScript } from '@/utils/util'
import { sleep } from '@/hooks/useTools'

/** 初始化 AAR 防刷 */
export async function loadAAR() {
  if (window.AAR2) return

  const url = 'https://jrsecstatic.jdpay.com/jr-sec-dev-static/aar2.min.js'

  await sleep(2500)
  loadScript(url, {
    async: true,
    callback: () => {
      try {
        window.AAR2 && window.AAR2.init()
      } catch (error) {
        reportSGM({ code: 'loadAAR_aar_init_error', err: error })
      }
    }
  })
}

export function getAARParams(data = {}) {
  if (!window.AAR2) {
    reportSGM({
      code: 'getAARParams_aar_env_error',
      res: {
        msg: '页面防刷组件环境或参数异常',
        data
      }
    })
    return data
  }

  try {
    const aar = new window.AAR2()
    const nonce = aar.nonce()
    const signData = typeof data === 'string' ? data : JSON.stringify(data)
    const signature = aar.sign(signData, nonce)
    console.log('signData', signData)
    return { nonce, signature, signData, ...data }
  } catch (error) {
    reportSGM({
      code: 'getAARParams_aar_run_error',
      res: {
        msg: '页面防刷组件执行异常',
        data
      },
      err: error
    })
    return data
  }
}
